// 用户相关API接口
import apiClient, { API_ENDPOINTS } from "@/config/api";

/**
 * 用户API类
 */
export class UserAPI {
  /**
   * 用户登录
   * @param {Object} loginData - 登录数据
   * @param {string} loginData.username - 用户名
   * @param {string} loginData.password - 密码
   * @returns {Promise} API响应
   */
  static async login(loginData) {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.USER.LOGIN,
        loginData
      );
      return {
        success: true,
        data: response,
        message: "登录成功",
      };
    } catch (error) {
      console.error("登录失败:", error);

      // 如果是API业务错误(code=0)，显示具体错误消息
      if (error.apiResponse) {
        return {
          success: false,
          data: null,
          message: error.apiResponse.msg || error.apiResponse.message || "登录失败",
        };
      }

      // 如果是HTTP错误响应，提取服务器返回的错误信息
      if (error.response && error.response.data) {
        const serverMessage = error.response.data.message || error.response.data.msg || error.response.data.error;
        return {
          success: false,
          data: null,
          message: serverMessage || "登录失败",
        };
      }

      // 如果是网络或其他错误
      return {
        success: false,
        data: null,
        message: error.message || "网络连接失败，请检查网络设置",
      };
    }
  }

  /**
   * 用户注册
   * @param {Object} registerData - 注册数据
   * @returns {Promise} API响应
   */
  static async register(registerData) {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.USER.REGISTER,
        registerData
      );
      return {
        success: true,
        data: response.data || response,
        message: "注册成功",
      };
    } catch (error) {
      console.error("注册失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "注册失败",
      };
    }
  }

  /**
   * 用户退出登录
   * @returns {Promise} API响应
   */
  static async logout() {
    try {
      const response = await apiClient.post(API_ENDPOINTS.USER.LOGOUT);
      return {
        success: true,
        data: response.data || response,
        message: "退出成功",
      };
    } catch (error) {
      console.error("退出失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "退出失败",
      };
    }
  }

  /**
   * 获取用户信息
   * @returns {Promise} API响应
   */
  static async getProfile() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.USER.PROFILE);
      return {
        success: true,
        data: response.data || response,
        message: "获取用户信息成功",
      };
    } catch (error) {
      console.error("获取用户信息失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "获取用户信息失败",
      };
    }
  }

  /**
   * 更新用户信息
   * @param {Object} userData - 用户数据
   * @returns {Promise} API响应
   */
  static async updateProfile(userData) {
    try {
      const response = await apiClient.put(
        API_ENDPOINTS.USER.UPDATE_PROFILE,
        userData
      );
      return {
        success: true,
        data: response.data || response,
        message: "更新用户信息成功",
      };
    } catch (error) {
      console.error("更新用户信息失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "更新用户信息失败",
      };
    }
  }

  /**
   * 重置密码
   * @param {Object} resetData - 重置密码数据
   * @returns {Promise} API响应
   */
  static async resetPassword(resetData) {
    try {
      const response = await apiClient.post(
        API_ENDPOINTS.USER.RESET_PASSWORD,
        resetData
      );
      return {
        success: true,
        data: response.data || response,
        message: "密码重置成功",
      };
    } catch (error) {
      console.error("密码重置失败:", error);
      return {
        success: false,
        data: null,
        message: error.message || "密码重置失败",
      };
    }
  }
}

export default UserAPI;
